import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ApiService } from '@services/api.service';
import * as Editor from '@ck/build/ckeditor';
import { MyUploadAdapter } from '@services/upload.adapter';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';

@Component({
	selector: 'app-edit-html',
	template: `
		<ckeditor
			#editorRef
			[editor]="Editor"
			[disabled]='editMode === false'
			(ready)="onReady($event)"
			[config]="ckeConfig"
			[ngModel]="model"
			(change)="change($event)"
			(blur)="blur.emit(model)"
			debounce="300"></ckeditor>
		<!--<div [innerHTML]="model"></div>-->
	`,
	styles: [`
      ::ng-deep ol,
      ::ng-deep ul {
          list-style: revert;
          margin: revert;
          padding: revert;
      }
	`],
})
export class EditHtml implements OnInit {
	@Input() editMode = true;
	@Input() placeholder = '';
	@Input() model;
	@Output() modelChange: EventEmitter<any> = new EventEmitter();
	@Output() blur: EventEmitter<any> = new EventEmitter();
	@ViewChild('editorRef') editorRef: ElementRef;
	editor: any;

	public Editor = Editor;
	ckeConfig: any;

	constructor(private apiService: ApiService) {}

	public change({ editor }: ChangeEvent) {
		const data = this.editor.getData();
		this.modelChange.emit(data);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['editMode']) {
			if (!changes['editMode'].firstChange) {
				this.updateToolBarVisibility();
			}
		}
	}

	ngOnInit(): void {
		if (this.placeholder && !this.model) this.model = this.placeholder;
		this.ckeConfig = {
			_apiService: this.apiService,
			extraPlugins: [TheUploadAdapterPlugin],
			removePlugins: ['Markdown', 'HtmlEmbed'],
			htmlSupport: false,
			toolbar: {
				items: [
					'heading',
					'fontSize',
					'fontColor',
					'fontBackgroundColor',
					// '|',
					'bold',
					'italic',
					'strikethrough',
					'blockQuote',
					'removeFormat',
					'bulletedList',
					'numberedList',
					'todoList',
					//'|',
					//'outdent',
					//'indent',
					'|',
					'link',
					'imageUpload',
					'mediaEmbed',
					//'resizeImage',
					// 'imageInsert',
					'insertTable',
					'codeBlock',
					'undo',
					'redo',
					//'code',
					'|',
					'horizontalLine',
					'sourceEditing',
					// 'findAndReplace'
				],
			},
			language: 'en',
			image: {
				toolbar: ['imageTextAlternative', 'imageStyle:inline', 'imageStyle:block', 'imageStyle:side', 'linkImage'],
				styles: ['full', 'side', 'alignLeft', 'alignCenter', 'alignRight'],
				resizeOptions: [
					{
						name: 'imageResize:original',
						label: 'Original',
						value: null,
					},
					{
						name: 'imageResize:50',
						label: '50%',
						value: '50',
					},
					{
						name: 'imageResize:75',
						label: '75%',
						value: '75',
					},
				],
			},
			table: {
				contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
			},
		};
	}

	private updateToolBarVisibility() {
		if (!this.editMode) {
			this.editor.ui.view.toolbar.element.style.display = 'none';
		} else {
			this.editor.ui.view.toolbar.element.style.display = 'flex';
		}
	}

	public onReady(editor) {
		this.editor = editor;
		this.updateToolBarVisibility();

		/*editor.ui.getEditableElement().parentElement.insertBefore(
			editor.ui.view.toolbar.element,
			editor.ui.getEditableElement()
		);*/
	}
}

class TheUploadAdapterPlugin {
	constructor(editor) {
		console.log('TheUploadAdapterPlugin ready');
		editor.plugins.get('FileRepository').createUploadAdapter = loader => {
			return new MyUploadAdapter(loader, editor.config._config._apiService);
		};
	}
}
